import { Section, SectionHeading, Card } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceMigration({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  const migrationSteps = config.migrationSteps;
  return (
    <Section max="5xl">
      <SectionHeading
        eyebrow={config.migrationEyebrow}
        navy={config.migrationHeadlineNavy}
        blue={config.migrationHeadlineBlue}
        breakLine={true}
        sub={config.migrationSub}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {migrationSteps.map((s, i) => (
          <Card key={i} radius={22}>
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-11 h-11 rounded-[14px] flex items-center justify-center shrink-0"
                style={{ background: "#EDF7FF" }}
              >
                <s.icon className="w-5 h-5" style={{ color: "#0B7CF2" }} />
              </div>
              <span
                className="font-display font-black select-none"
                style={{
                  fontSize: "28px",
                  lineHeight: 1,
                  color: "rgba(17,143,247,0.12)",
                  letterSpacing: "-0.04em",
                }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <h3
              className="font-display font-bold mb-2"
              style={{
                fontSize: "18px",
                color: "#071E61",
                letterSpacing: "-0.02em",
              }}
            >
              {s.title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                lineHeight: 1.5,
                color: "#536B89",
              }}
            >
              {s.desc}
            </p>
          </Card>
        ))}
      </div>
      <p
        className="text-center mt-10 font-display font-bold max-w-2xl mx-auto"
        style={{
          fontSize: "19px",
          lineHeight: 1.4,
          color: "#071E61",
          letterSpacing: "-0.02em",
        }}
      >
        {config.migrationConclusionPre}{" "}
        <span style={{ color: "#0B7CF2" }}>
          {config.migrationConclusionBlue}
        </span>
      </p>
      <SectionCta
        copy={config.migrationCtaCopy}
        label={config.migrationCtaLabel}
      />
    </Section>
  );
}
